<div class="modal-header">
    <h4 class="modal-title">Totales</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-divider class="mt-2"></mat-divider>

<mat-dialog-content class="mat-typography">
    <!-- Barra de progreso superior -->
    <div class="row mb-3 mt-2" *ngIf="totalCount > 0">
        <div class="col">
            <div class="d-flex justify-content-between align-items-center mb-1">
                <mat-label>Progreso de materiales:</mat-label>
                <span class="text-muted small">
                    Confirmados: {{ confirmedCount }} de {{ totalCount }}
                </span>
            </div>
            <mat-progress-bar mode="determinate" [value]="progressPercent"></mat-progress-bar>
            <p class="text-end mt-1 mb-0 small fw-semibold text-primary">
                {{ progressPercent | number:'1.1-1' }}%
            </p>
        </div>
    </div>

    <!-- Buscador y botón de descarga -->
    <div class="overflow-auto w-100">
        <div class="float-end">
            <button 
                mat-raised-button 
                color="primary" 
                class="mt-2 mb-2"
                (click)="downloadExcel()" 
                [disabled]="dataSource.data.length === 0"
                matTooltip="Descargar listado en Excel">
                Descargar excel <mat-icon>download</mat-icon>
            </button>
        </div>
        <mat-form-field>
            <mat-label>
                <mat-icon>search</mat-icon> Buscar material
            </mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ej. Unibanner, S13506, Confirmado..." #input>
        </mat-form-field>
    </div>

    <div class="mat-elevation-z8 table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100">
            <!-- Columna # -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef style="width: 50px;"> # </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    {{ (paginator ? paginator.pageIndex * paginator.pageSize : 0) + i + 1 }}
                </td>
            </ng-container>

            <!-- Nombre Operativo -->
            <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE OPERATIVO </th>
                <td mat-cell *matCellDef="let element">
                    <strong>{{ element.nombre || 'Sin nombre' }}</strong>
                </td>
            </ng-container>

            <!-- Cantidad -->
            <ng-container matColumnDef="cantidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> CANTIDAD </th>
                <td mat-cell *matCellDef="let element">
                    {{ (element.cantidad ?? 0) | number }}
                </td>
            </ng-container>

            <!-- Folio -->
            <ng-container matColumnDef="folio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> FOLIO </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.folio || '-' }}
                </td>
            </ng-container>

            <!-- Estatus Folio -->
            <ng-container matColumnDef="estatus_folio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> ESTATUS FOLIO </th>
                <td mat-cell *matCellDef="let element">
                    <span 
                        *ngIf="element.status_buho != null; else sinEstatus"
                        class="badge" 
                        [ngClass]="getBadgeClass(element.status_buho)">
                        {{ getStatusBuhoName(element.status_buho) }}
                    </span>
                    <ng-template #sinEstatus>
                        <span class="text-muted">-</span>
                    </ng-template>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Fila sin resultados -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell py-3" colspan="5">
                    No existe información que coincida con "{{ input.value }}"
                </td>
            </tr>
        </table>
    </div>

    <mat-paginator 
        [pageSizeOptions]="[10, 25, 100]" 
        showFirstLastButtons>
    </mat-paginator>
</mat-dialog-content>

<mat-dialog-actions align="end" class="mt-2">
    <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>